import { setDoc, deleteDoc, doc, updateDoc, collection, onSnapshot } from 'firebase/firestore';
import { v4 as uuidv4 } from 'uuid';

import { Option } from 'shared/types';

import { firestore } from '../Common/Firebase';

const collectionName = 'Subjects';
const colRef = collection(firestore, collectionName);
const getDocRef = (id: string) => doc(firestore, collectionName, id);

async function addSubject(subject: Omit<Option, 'id'>) {
  const newId = uuidv4();
  const newSubject = { id: newId, ...subject };
  const docRef = getDocRef(newId);

  await setDoc(docRef, newSubject);
}

async function updateSubject(subject: Option) {
  const docRef = getDocRef(subject.id);

  await updateDoc(docRef, { ...subject });
}

async function removeSubject(id: string) {
  const docRef = getDocRef(id);

  await deleteDoc(docRef);
}

function subscribeToChanges(updateSubjects: (subjects: Option[]) => void) {
  return onSnapshot(colRef, snapshot => {
    const subjects: Option[] = [];
    snapshot.forEach(doc => subjects.push({ ...doc.data(), id: doc.id } as Option));

    updateSubjects(subjects);
  });
}

export const subjectsApi = {
  addSubject,
  removeSubject,
  updateSubject,
  subscribeToChanges,
};
